import { useEffect, useState } from 'react';
import * as RouteConfigurationService from 'src/services/config/domain/RouteConfigurationService/RouteConfigurationService.client';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import * as ApplicationConfigurationService from 'src/services/config/ApplicationConfigurationService.client';

/**
 * For most paths, we can redirect exactly the same. Exception to this rule being /login/dashboard which is permanently
 * sunset
 */
const getFinalDestinationForLoginDashboard = (path: string): string =>
    path.replace('/login/dashboard', '/mortgage/dashboard/login');

export const useMigrateToZillowState = () => {
    const config = ApplicationConfigurationService.ConfigProvider.getInstance();
    const [isRedirectDecisionMade, setIsRedirectDecisionMade] = useState(false);
    useEffect(() => {
        if (
            window.location.hostname.includes(RouteConfigurationService.Domain.OriginIdentifier.ZILLOW) ||
            config.runtimeConfig.isCurrentRuntimeEnvironmentRedirectExempt
        ) {
            setIsRedirectDecisionMade(true);
            return;
        }
        const redirectToZillow = async () => {
            const [, relativePath] = window.location.href.split(window.location.hostname);
            const sanitizedRelativePath = getFinalDestinationForLoginDashboard(relativePath);

            const zillowEquivalentPath = new ZillowHomeLoansURL(sanitizedRelativePath).resolvedURL;
            await DatadogRUMService.Client.getInstance().addAction(DatadogRUMService.CustomAction.MIGRATION_REDIRECT, {
                from: relativePath,
                to: zillowEquivalentPath,
            });
            window.location.replace(zillowEquivalentPath);
        };
        redirectToZillow();
    }, [config.runtimeConfig.isCurrentRuntimeEnvironmentRedirectExempt]);

    return {
        isRedirectDecisionMade,
    };
};
